import React from "react";
import Chart from "react-apexcharts";

const StateChart = ({ title, values }) => {
  const chartValues = [];
  const chartKeys = [];

  if (values) {
    const total = values.reduce((sum, ele) => sum + ele.count, 0); // Calculate total sum

    values.forEach((ele) => {
      chartValues.push(ele.count);
      const percentage = ((ele.count / total) * 100).toFixed(2); // Convert count to percentage
      chartKeys.push(`${ele.name} (${percentage}%)`); // Append percentage to label
    });
  }

  const options = {
    chart: {
      width: 360,
      type: "donut",
    },
    responsive: [
      {
        breakpoint: 360,
        options: {
          chart: {
            width: 360,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    labels: chartKeys,
    legend: {
      position: "bottom",
      fontSize: "14px",
      labels: {
        colors: "#fff",
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: (_, { seriesIndex }) => {
          return ""; // Ensures only "Crypto (22.10%)" appears once
        },
      },
    },
  };

  return (
    <>
      <div>
        <h1>Top {title}</h1>

        <div className="donut">
          <Chart
            options={options}
            series={chartValues}
            type="donut"
            width={500}
          />
        </div>
        <div>
          <span></span>
        </div>
      </div>
    </>
  );
};

export default StateChart;
